import { FC } from 'react';
import StepTitle from './StepTitle';

const ContactApplicationTitle: FC = () => (
  <StepTitle
    title="Add Contact & Application Details"
    description="Please enter a contact person for this job listing. This information is used only for billing and editing purposes and will not be displayed publicly."
  />
);

export default ContactApplicationTitle;
